import { Injectable } from '@angular/core';
import { Form } from '../models/form.model';
import { Section } from '../models/section.model';
import { QuestionType } from '../models/question/question-type.model';
import { QuestionStructureSarskildaVillkor } from '../models/question/question-sarskillda-vilkor.model';
import { Question } from '../models/question/question.model';

@Injectable({
  providedIn: 'root',
})
export class SarskildaVillkorService {
  public addSarskildaVillkorSection(
    form: Form,
    sarskildaVillkor: SarskildaVillkor[],
    anvisningarRekommendationer: AnvisningarRekommendationer,
  ) {
    if (
      !sarskildaVillkor ||
      (sarskildaVillkor.length === 0 && !anvisningarRekommendationer)
    ) {
      return form;
    }

    const section = form.sections.find((section) =>
      section.questions.some(
        (question) => question.type === QuestionType.SarskildaVillkor,
      ),
    ) as Section;

    if (!section) {
      return form;
    }

    const question = section.questions[0] as Question;
    question.structure = {
      sarskildaVillkor: sarskildaVillkor.map((sv) => {
        return { id: sv.id, text: sv.textSv };
      }),
      anvisningarRekommendationer: anvisningarRekommendationer
        ? anvisningarRekommendationer.textSv
        : undefined,
    } as QuestionStructureSarskildaVillkor;

    for (const sarskiltVillkor of sarskildaVillkor) {
      question.translations.list[sarskiltVillkor.id] = {
        en: sarskiltVillkor.textEn,
      };
    }
    if (anvisningarRekommendationer) {
      question.translations.list['anvisningarRekommendationer'] = {
        en: anvisningarRekommendationer.textEn,
      };
    }

    return form;
  }
}

export interface SarskildaVillkor {
  textSv: string;
  textEn: string;
  id: string;
}

export interface AnvisningarRekommendationer {
  textSv: string;
  textEn: string;
}
